import { useImmerReducer } from 'use-immer';
const initialActivityFeedBlockState = {
  expandedReplies: []
};

/**
 * Reducer for managing UI-related state in the ActivityFeed block.
 * This does not modify any ActivityFeed list data.
 * ActivityFeed data will be handled by whammy in useFeedItemReducers.
 */
const activityFeedReducer = (draft, action) => {
  switch (action.type) {
    case 'SHOW_REPLIES':
      {
        draft.expandedReplies.push(action.feedItemId);
        break;
      }
    case 'HIDE_ALL_REPLIES':
      {
        draft.expandedReplies.splice(0);
        break;
      }
    default:
      /* @ts-expect-error -- TS complains about action.type because all actions are covered 💪 */
      throw Error(`Unknown action: ${action.type}`);
  }
};
export const useActivityFeedBlockReducer = () => useImmerReducer(activityFeedReducer, initialActivityFeedBlockState);